import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CookieService {

    dataLayer = window.dataLayer || [];

    gtag = (...args: any[]) => {
        window.dataLayer.push(args);
    };

    renderer: Renderer2;

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    addDataLayer() {
        if (!window['dataLayer']) {
            window['dataLayer'] = [];
        }
        this.gtag = function () {
            window['dataLayer'].push(arguments);
        };
    }

    loadGtagScripts(googleTagId: string) {
        const gtmScript = this.renderer.createElement('script');
        gtmScript.async = true;
        gtmScript.src = `https://www.googletagmanager.com/gtag/js?id=${googleTagId}`;
        this.renderer.appendChild(document.head, gtmScript);

        const gtmInitScript = this.renderer.createElement('script');
        gtmInitScript.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${googleTagId}', { 'debug_mode': true });
    `;
        this.renderer.appendChild(document.head, gtmInitScript);
    }

    setDefaultConsent() {
        this.gtag('consent', 'default', {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            analytics_storage: 'denied',
        });
    }

    acceptConsent(cookieObject: any) {
        this.gtag('consent', 'update', {
            ad_storage: cookieObject.googleAdsGtagVariable,
            ad_user_data: cookieObject.googleAdsGtagVariable,
            ad_personalization: cookieObject.googleAdsGtagVariable,
            analytics_storage: cookieObject.googleAnalyticsGtagVariable,
        });

        window['dataLayer'].push({
            event: 'user_consent_update',
            consent: {
                ad_storage: cookieObject.googleAdsGtagVariable,
                ad_user_data: cookieObject.googleAdsGtagVariable,
                ad_personalization: cookieObject.googleAdsGtagVariable,
                analytics_storage: cookieObject.googleAnalyticsGtagVariable,
            },
        });
    }
}
